import React from "react";
import {
  FlexHeader,
  CustomDivider,
  CustomFilteringTitle,
  CustomTag,
  ClearAllButton,
} from "./styles";
import { useConfig } from "../../../data/useConfig";

const FilterHeader = ({
  selectedFilters,
  closeTag,
  clearFilters,
  showMobile = true,
  filterData,
}) => {
  const { areFiltersAvailable, filterDirection } = useConfig();

  const findFilter = (filterName) =>
    Object.values(filterData?.meta?.filters_available)?.find(
      (filtered) => filtered.facet === filterName
    );

  const findFilterValue = (filterName, value) => {
    const { values } = findFilter(filterName);
    return (
      Object.values(values).find((fValue) => fValue[0] === value)?.[1] || value
    );
  };

  const closeDoubleValueTags = (e, name, values) => {
    values.forEach((value) => closeTag(e, value, name));
  };

  const generateTag = (name, values) => {
    const filter = findFilter(name);
    const { label, type } = filter;

    if (type === "range") {
      const { frontType } = filter;
      return (
        <CustomTag
          className="bnly-search__filter-tag"
          closable
          onClose={(e) => closeDoubleValueTags(e, name, values)}
        >{`${frontType} ${values[0]} ~ ${values[1]}`}</CustomTag>
      );
    }

    if (typeof values === "string") {
      return (
        <CustomTag
          className="bnly-search__filter-tag"
          closable
          onClose={(e) => closeTag(e, values, name)}
          key={`tag-${findFilterValue(name, values)}`}
        >
          {`${label}: ${findFilterValue(name, values)}`}
        </CustomTag>
      );
    }

    return values.map((v) => (
      <CustomTag
        key={`tag-${findFilterValue(name, v)}`}
        className="bnly-search__filter-tag"
        closable
        onClose={(e) => closeTag(e, v, name)}
      >
        {`${label}: ${findFilterValue(name, v)}`}
      </CustomTag>
    ));
  };

  return (
    <FlexHeader
      className="bnly-search__filter-header"
      areFiltersAvailable={areFiltersAvailable}
      filterDirection={filterDirection}
      showMobile={showMobile}
    >
      {selectedFilters.length > 0 && (
        <>
          <CustomFilteringTitle className="bnly-search__filtering-title">
            Filtrando por:
          </CustomFilteringTitle>

          {selectedFilters.map(({ name, values }) => generateTag(name, values))}

          <ClearAllButton
            className="bnly-search__filter-clear-btn"
            filterDirection={filterDirection}
            onClick={clearFilters}
          >
            Limpar tudo
          </ClearAllButton>

          <CustomDivider className="bnly-search__filter-divider" />
        </>
      )}
    </FlexHeader>
  );
};

export default FilterHeader;
